import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@rp/environments';
import { Observable } from 'rxjs';

import {
  PayoutResponse,
  PayoutRequest,
  PayoutHistory,
  PayoutMethod,
  PayoutMethodRequest,
  PayoutBalance,
  PayoutHistoryRequest,
  Payout,
} from '../models';
import { FinanceWebmasterProvider } from './finance-webmaster.provider';
import { PayoutHistoryAdapter } from '../adapters';

@Injectable()
export class HttpFinanceWebmasterProvider implements FinanceWebmasterProvider {
  private readonly _baseWebMasterUrl = `${environment.apiConfig.userApiHost}`;
  private readonly _baseUrl = `${this._baseWebMasterUrl}/payouts/webmaster/`;

  private readonly _httpClient = inject(HttpClient);

  getPayouts(filters: string): Observable<PayoutResponse> {
    return this._httpClient.get<PayoutResponse>(`${this._baseUrl}?${filters || ''}`);
  }

  getPayout(payoutId: number): Observable<Payout> {
    return this._httpClient.get<Payout>(`${this._baseUrl}${payoutId}/`);
  }

  makePayout(request: PayoutRequest): Observable<void> {
    return this._httpClient.post<void>(this._baseUrl, request);
  }

  getPayoutsHistory(request: PayoutHistoryRequest): Observable<PayoutHistory[]> {
    return this._httpClient.get<PayoutHistory[]>(
      `${this._baseUrl}${request.payoutId}/history/?${PayoutHistoryAdapter.toRestHistoryParams(request)}`,
    );
  }

  getPayoutsMethod(): Observable<PayoutMethod[]> {
    return this._httpClient.get<PayoutMethod[]>(`${this._baseUrl}payout_methods/`);
  }

  sendPayoutMethod(request: PayoutMethodRequest): Observable<void> {
    return this._httpClient.post<void>(`${this._baseUrl}payout_methods/`, request);
  }

  deletePayoutMethod(id: number): Observable<void> {
    return this._httpClient.delete<void>(`${this._baseUrl}payout_methods/${id}/`);
  }

  setActivePayoutMethod(id: number, isActive: boolean): Observable<void> {
    return this._httpClient.post<void>(`${this._baseUrl}payout_methods/set_active/`, {
      isActive,
      paymentMethodId: id,
    });
  }

  getMyBalance(): Observable<PayoutBalance> {
    return this._httpClient.get<PayoutBalance>(`${this._baseWebMasterUrl}/users/balance/`);
  }

  getPayoutsCSV(filters?: string): Observable<Response> {
    return this._httpClient.get<Response>(`${this._baseUrl}csv/?${filters || ''}`);
  }
}
